import React from 'react';
import { NavLink } from 'react-router-dom';

const NavLinkAdapter = React.forwardRef((props, ref) => <NavLink innerref={`${ref}`} {...props} />);

NavLinkAdapter.displayName = 'NavLinkAdapter';

export default NavLinkAdapter;
